import React, {useEffect, useRef, useState} from "react";
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { createPortal } from "react-dom";
import MarcadorGoT from "./Marcador2";
import 'mapbox-gl/dist/mapbox-gl.css';
import Popup from "./popup";
import PopupOtb from "./popupOTB";
import { Button } from "@material-ui/core";
import { useScreenshot } from 'use-react-screenshot'
import PopupInicio from "./popupInicio";
//import { Stage, Layer, Image} from 'react-konva';
//import { Html } from 'react-konva-utils';
const useStyles = makeStyles({
    miclase:{".map-container":{
        height: "400px",
      }},
  });
 

function Mapa({lista, listMarcador, listEleccion, contador,listRutaGps, listNumOtb,listColPolig  }) {

    
    const classes = useStyles();
    const mapContainer = useRef(null);
    const mapRef = useRef(null);
    const mapaScreen = useRef()
    const [long] = useState(-66.15492523373541); 
    const [lat] = useState(-17.41283598717285 );
    const [zoom] = useState(13);       
    const [regisSelect, setRegisSelect] = useState([]);
    const [regisInicio, setRegisInicio] = useState([]);
    const [regisFin, setRegisFin] = useState([]);
    const [marcadores, setMarcadores] = useState([]);
    const [regisPopUp, setRegisPopUp] = useState([]);
    const [regisPopUpOtb, setRegisPopUpOtb] = useState([]);
    const [listaNum, setListaNum] = useState([]);
    const [listaPolylineas, setListaPolylineas] = useState([]);
    const [hoveredDistrict, _setHoveredDistrict] = useState(null);

    const [image, takeScreenshot] = useScreenshot()
    const getImage = () =>{
       // console.log("antesscreen");
        
        // takeScreenshot(mapContainer.current)
      /*   const imgData = mapaScreen.current.toDataURL({ //transforma el objeto stage en 
                mimeType:"image/png",
                quality: 1,
                pixelRatio: 3
            })       */
        const imgData = mapRef.current.getCanvas().toDataURL('image/png')
        const link = document.createElement('a')
        link.download = "mapbox-scree.png"
        link.href = imgData
        link.click()
    }
    let hoveredStateId = null;
    let stateName = null;
    
    useEffect(() => {       
        
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        mapRef.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/light-v10",
            center: [lista[0][0], lista[0][1]],
            preserveDrawingBuffer:true,
            zoom: zoom            
        });
                 
        setRegisSelect(lista)
        setListaPolylineas(listRutaGps)

        return () => {
            mapRef.current.remove()
        }
    }, [    ]);

    useEffect(()=>{
       if (lista.length!==0) {
        
        const auxCoordenadas=lista        
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('maine', {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Polygon',
                        // These coordinates outline Maine.
                        'coordinates': [
                            auxCoordenadas
                        ]
                    }
                }
            });

            // Add a new layer to visualize the polygon.
          /*   mapRef.current.addLayer({
                'id': 'maine',
                'type': 'fill',
                'source': 'maine', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': '#0080ff', // blue color fill
                    'fill-opacity': 0.5
                }
            }); */
            // Add a black outline around the polygon.
            mapRef.current.addLayer({
                'id': 'outline',
                'type': 'line',
                'source': 'maine',
                'layout': {},
                'paint': {
                    'line-color': '#24AF88',
                    'line-width': 3
                }
            });
            });
            //setMarcadores(listMarcador)
        }
 
    },[lista ])

     useEffect(()=>{
       if (listaPolylineas.length!==0) {        
        const auxCoordenadas=listaPolylineas        

        const nvo={ properties:{texto: "Inicio"},
            geometry:{coordinates:auxCoordenadas[0]}}        
        const nvo2={ properties:{texto: "Fin"},
            geometry:{coordinates:auxCoordenadas[auxCoordenadas.length-1]}}        
        setRegisFin(nvo2)
        setRegisInicio(nvo)

        mapRef.current.flyTo({
          center: auxCoordenadas[0],
          zoom:15
        });
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('lineaRutas', {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'LineString',
                        // These coordinates outline Maine.
                        'coordinates':auxCoordenadas
                       /*    [-66.16224020719528,-17.3648812845065],              
                            [-66.16776924580336,-17.36307618159081], */                                    
                        }
                }
            });

            // Add a new layer to visualize the polygon.
            mapRef.current.addLayer({
                'id': 'dot-lineaRutas',
                'type': 'line',
                'source': 'lineaRutas', // reference the data source
                'layout': {
                    'line-join': 'round',
                    'line-cap': 'round'},
                'paint': {
                    'line-color': '#0080ff', // blue color fill
                    //'line-dasharray': [0.2, 3], para convertirlo en linea punteada
                    'line-width': 8
                }
            }); 
            // Add a black outline around the polygon.
            /* mapRef.current.addLayer({
                'id': 'outline',
                'type': 'line',
                'source': 'lineaRutas',
                'layout': {},
                'paint': {
                    'line-color': '#68a3de',
                    'line-width': 3
                }
            }); */
            });           
        }
 
    },[listaPolylineas ])



    const onClickUnidad=(aux)=>{
                
        const nvo={...aux,
            properties:{texto: aux.original.nom, dir: aux.original.dir, 
                otb:aux.original.otbNom},
            geometry:{coordinates:aux.coordinates}}        
        setRegisPopUpOtb([])
        setRegisPopUp(nvo)
    }

    const onClickOtb=(aux)=>{
        
        setRegisPopUp([])
        let textoEleccionArr=[]
        if (listEleccion.length!==0) {
            const filtro = listEleccion.filter((eleccion)=> eleccion.Otb===aux.Ord)
            if (filtro.length!==0) {
                textoEleccionArr={...filtro[0] }    
            }
                        
        }
        setRegisPopUpOtb({...aux,
            properties:{texto: aux.Nom, ...textoEleccionArr},
            geometry:{coordinates:aux.coordinates}})
    }

    return (
    <div className={classes.miclase} style={{width:window.innerWidth - 290,height: window.innerHeight - 140}} >
       
       {/* <Button style={{ marginBottom: '10px' }} onClick={getImage} > Clonar</Button> */}
       
        <div id="districtDetailMap" className={"map"} >
            <div style={{width:window.innerWidth - 290,height: window.innerHeight - 140}} ref={mapContainer}>
                {marcadores.length !== 0 ?
                marcadores.map((elemento,index)=>
                    <MarcadorGoT
                    key={elemento.original.id}
                    map={mapRef.current}
                    feature={elemento}
                    onClick={onClickUnidad}
                /> 
                )
               
            :null }
           
            {listaNum.length !== 0 ?
                listaNum.map((elemento,index)=>{
                    const estilo = elemento.Ord < 10 ?{width:"20px", height:"35px"}:{width:"30px", height:"38px"}
                    return<MarcadorGoT
                    key={elemento.id}
                    map={mapRef.current}
                    feature={elemento}
                    onClick={onClickOtb}
                    estilo={estilo}
                    url={`https://daduva-cartografia.sfo3.cdn.digitaloceanspaces.com/Sec/Secc${elemento.Ord}.svg`}
                /> 
               } )
               
            :null  }

            {mapRef.current && regisPopUp.length!==0 ? (
                <Popup
                    map={mapRef.current}
                    activeFeature={regisPopUp}
                />
            )
            :null}

            {mapRef.current && regisPopUpOtb.length!==0 ? (
                <PopupOtb
                    map={mapRef.current}
                    activeFeature={regisPopUpOtb}
                />
            )
            :null}

            {mapRef.current && regisInicio.length!==0 ? (
                <PopupInicio
                    map={mapRef.current}
                    activeFeature={regisInicio}
                />
            )
            :null}
            {mapRef.current && regisFin.length!==0 ? (
                <PopupInicio
                    map={mapRef.current}
                    activeFeature={regisFin}
                />
            )
            :null}
            
            </div>             
        </div>              
    </div>
    );
}

export default Mapa;